/**
 * @file ButtonHeightField.tsx
 * @description Высота кнопки числом (phase19.16, партия SB120, этап 3а;
 * uiux-sb120-stage3 §3 «Кнопка», решение 3 «числом в этом этапе»; данные
 * db-design-sb120-stage3 §2 `button.height`): 40–72 px, подсказки [40][48][56],
 * «↺ 48» снимает ключ. Это наименьшая высота — длинный текст растит кнопку.
 * Ниже 48 px — предупреждение (SB7: пальцем трудно попасть), не запрет.
 */

import { SECTION_LOOK_LIMITS } from "@chaiberi/shared";

import { NumberSliderField } from "../../../site-fields/NumberSliderField";
import { useSectionForm } from "../section-form-context";

const H = SECTION_LOOK_LIMITS.buttonHeight;

export const BUTTON_HEIGHT_WARNING = "Ниже 48 px — пальцем трудно попасть (SB7). Можно оставить.";

interface Props {
  value: number | undefined;
  onChange: (height: number | undefined) => void;
  /** Путь элемента — живой предпросмотр `…height`. */
  path: string;
}

export function ButtonHeightField({ value, onChange, path }: Props) {
  const { preview } = useSectionForm();
  return (
    <NumberSliderField
      label="Высота"
      value={value}
      inherit={{ value: H.default, label: `${H.default} px` }}
      min={H.min}
      max={H.max}
      step={1}
      unit="px"
      display={{ factor: 1, decimals: 2 }}
      presets={[
        { label: "40", value: 40 },
        { label: "48", value: 48 },
        { label: "56", value: 56 },
      ]}
      recommended={{ min: 48, max: H.max, text: BUTTON_HEIGHT_WARNING }}
      hint="Наименьшая высота: длинный текст растит кнопку."
      onChange={onChange}
      onPreview={(v) => preview(`${path}.height`, v)}
    />
  );
}
